import React, { useState, useEffect } from "react";
import axios from "axios";
import User from "./User";
import Done from "./Done";
import Steps from "./Steps";
import Error from "./Error";
import Loading from "./Loading";
import Company from "./Company";
import useValidateObject from "@hooks/useValidateObject";

const companyValidation = {
    name: "required|max:50",
    city: "required|max:150",
    category: "required|max:150",
    delivery: "required|max:150",
};
const userValidation = {
    name: "required|max:50",
    email: "email|required|max:50",
    phone: "digits_between:1,20|required",
    password: "required|min:8",
    passwordConfirm: "required|min:8|same:password",
};
const Register = () => {
    useEffect(() => {
        getSettings();
    }, []);
    const [current, setcurrent] = useState("company");
    const [logo, setLogo] = useState("");
    const [validateCurrent, setValidateCurrent] = useState({
        company: false, // true = validate correct
        user: false,
    });
    const [dataCompany, setDataCompany] = useState({
        name: "",
        city: "",
        category: "",
        delivery: "",
    });
    const [dataUser, setDataUser] = useState({
        name: "",
        email: "",
        phone: "",
        password: "",
        passwordConfirm: "",
    });
    const messageCompany = {
        name: "Nombre es requerido",
        city: "Ciudad es requerido",
        category: "Categoria es requerido",
        delivery: "Cantidad es requerido",
    };
    const messageUser = {
        name: "Nombre de usuario es requerido ",
        email: "Email de usuario es requerido",
        phone: "telefono es requerido",
        password: "password es requerido",
        passwordConfirm: "password requerido",
    };
    const [isValidCompany, isValidCompanyError] = useValidateObject(dataCompany, companyValidation, messageCompany);
    const [isValidUser, isValidUserError] = useValidateObject(dataUser, userValidation, messageUser);
    const companyId = 3411;
    const type = "tracking_page";
    function getSettings() {
        axios
            // .get(`http://localhost:8030/companies/${companyId}/settings/${type}`)
            .get(`https://dash.shippify.co/companies/${companyId}/settings/${type}`)
            .then((response) => {
                console.log("response - settings", response);
                if (response.data.custom.properties) {
                    setLogo(response.data.custom.properties.logo);
                }
            })
            .catch((err) => console.error("err", err));
    }
    return (
        <div>
            <Steps current={current} validateCurrent={validateCurrent} logo={logo} />
            {current === "company" ? (
                <Company
                    setDataCompany={setDataCompany}
                    dataCompany={dataCompany}
                    setValidateCurrent={setValidateCurrent}
                    isValidCompanyError={isValidCompanyError}
                    isValidCompany={isValidCompany}
                    validateCurrent={validateCurrent}
                    setcurrent={setcurrent}
                />
            ) : current === "user" ? (
                <User
                    setcurrent={setcurrent}
                    setValidateCurrent={setValidateCurrent}
                    setDataUser={setDataUser}
                    dataUser={dataUser}
                    validateCurrent={validateCurrent}
                    isValidUserError={isValidUserError}
                    isValidUser={isValidUser}
                    dataCompany={dataCompany}
                />
            ) : current === "done" ? (
                <Done dataUser={dataUser} />
            ) : current === "error" ? (
                <Error />
            ) : (
                current === "loading" && <Loading />
            )}
        </div>
    );
};
export default Register;
